export { default as AtlassianAccountLogo } from './AccountLogo';
